import React, { FC, ReactElement, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
// Components
import { Typography } from '@mui/material';
import InputField from '../../../components/form/input';
import EditReservationWrapper from './editReservationWrapper';
import Loader from '../../../components/loader';
// Hooks
import { useUpdateRide } from '../../../core/services/rides';
import { useGetPolicies } from '../../../core/services/policies';
// Resources
import { stringsRes } from '../../../resources/strings';
import { EditRideInput, GetPoliciesOutput, Ride } from '../../../core/apiTypes';
import { PropsFromModal } from '../../../components/modals/createModalHOC';
import { MIN_CHAR_RIDE_REASON } from '../../../utils/constants';
import { isBetween } from '../../../utils/strings';
import { isWebView } from '../../../utils/webview';

interface EditReservationRideReasonProps extends PropsFromModal {
    reservation: Ride;
}

const EditReservationRideReason: FC = (props: EditReservationRideReasonProps): ReactElement => {
    const { reservation, onRequestClose } = props;

    const classes = useStyles();

    const [message, setMessage] = useState<string>('');

    const { data: groupPolicyDatas, isFetching } = useGetPolicies<GetPoliciesOutput>({
        enabled: !!reservation.group?.uuid,
        variables: { groups: [reservation?.group?.uuid] },
    });
    const groupPolicy = groupPolicyDatas?.group?.[0];

    const updateRide = useUpdateRide();
    // const { id } = useParams();
    // const { data: reservation } = useGetReservation<Job>({
    //     enabled: !!id,
    //     variables: { id },
    // });

    useEffect(() => {
        if (reservation?.ride_reason) {
            setMessage(reservation.ride_reason);
        }
    }, [reservation]);

    const onMessageChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setMessage(event.target.value);
    };

    const onConfirm = (): void => {
        const payload: EditRideInput = {
            id: reservation.id,
            ride_reason: message?.trim(),
        };

        updateRide.mutate(payload, {
            onSuccess: () => {
                onRequestClose();
            },
        });
    };

    if (isFetching) {
        return <Loader />;
    }

    const isWebview = isWebView();

    return (
        <EditReservationWrapper
            {...props}
            description={
                groupPolicy?.travel_reason_mandatory
                    ? stringsRes.booking.rideReasonDetailsMandatory
                    : stringsRes.booking.rideReasonDetailsNotMandatory
            }
            onConfirm={onConfirm}
            disableConfirm={
                (groupPolicy?.travel_reason_mandatory && message?.trim()?.length < MIN_CHAR_RIDE_REASON) ||
                (!groupPolicy?.travel_reason_mandatory && isBetween(message, 1, 2))
            }
            loadingConfirm={updateRide.isLoading}
        >
            <InputField
                name="message"
                label={
                    <Typography variant="body1" noWrap className={classes.labelCustomStyle}>
                        {stringsRes.booking.rideNote}
                    </Typography>
                }
                value={message}
                autoFocus={!isWebview}
                onChange={onMessageChange}
                minRows={5}
                maxRows={10}
                InputProps={{ disableUnderline: true }}
                multiline
                className={classes.textArea}
                onFocus={(e: any) => {
                    const tmp = e.target.value;
                    e.target.value = '';
                    e.target.value = tmp;
                }}
            />
        </EditReservationWrapper>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        textArea: {
            flex: 1,
            width: '100%',
        },
        labelCustomStyle: {
            fontWeight: 500,
            fontSize: 16,
        },
    }),
);

export default EditReservationRideReason;
